<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="1"></top-logo>
    <!-- <right-nav></right-nav> -->
    <home-nav></home-nav>
    <div>
      <div class="w">
        <div class="site-nav">
          <router-link :to="{ name: 'index' }">首页</router-link>>
          <router-link :to="{ name: 'user-center' }">个人中心</router-link>>
          个人信息
        </div>
        <left-userinfo state="3"></left-userinfo>
        <div class="right-refund-wrap">
          <div class="title">
            <h2>售后记录</h2>
          </div>
          <table
            class="order-detail-list-wrapper"
            cellspacing="0"
            v-if="refundList && refundList.length > 0"
          >
            <thead>
              <tr class="order-list-thead">
                <th>退换/售后编号</th>
                <th>订单编号</th>
                <th style="width:330px !important;">商品名称</th>
                <th>申请时间</th>
                <th>全部状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody class="order-detail-list">
              <tr v-for="item in refundList" :key="item.workorder_id">
                <td>{{ item.workorder_id }}</td>
                <td>{{ item.order_info && item.order_info.order_id }}</td>
                <td class="goods-name">{{ item.order_product_name }}</td>
                <td>{{ item.date_added | dateFormat }}</td>
                <td :class="{ red_word: item.status == 1 }">
                  {{ item.status_name }}
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'refund-detail',
                      params: { workorder_id: item.workorder_id }
                    }"
                    >查看详情</router-link
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <is-empty v-if="isEmpty"></is-empty>
        </div>
      </div>
    </div>
    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import LeftUserinfo from "@/components/left-userinfo";
import IsEmpty from "@/components/is-empty";

export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    LeftUserinfo,
    IsEmpty
  },
  data() {
    return {
      refundList: [],
      isEmpty: false
    };
  },
  mounted() {
    this.name = window.sessionStorage.getItem("name");
    this.getData();
  },
  methods: {
    getData() {
      this.$reqGet("api/store/workorder").then(res => {
        this.refundList = res.data.data;
        if (this.refundList.length == 0) {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.site-nav {
  padding: 20px 0;
  color: #999;
  font-size: 16px;
  a {
    color: #999;
  }
  a:first-child {
    color: #444;
  }
}
.right-refund-wrap {
  // position: relative;
  margin-bottom: 40px;
  min-height: 572px;
  width: 980px;
  margin-left: 220px;
  box-sizing: border-box;
  padding: 10px 25px 0;
  background-color: #fff;
  .title {
    line-height: 42px;
    height: 42px;
    border-bottom: 2px solid #dadada;
    margin-bottom: 30px;
    h2 {
      width: 120px;
      border-bottom: 2px solid #e2333f;
      font-size: 20px;
      font-weight: normal;
      margin: 0;
      box-sizing: border-box;
      padding-left: 20px;
    }
  }
  .order-detail-list-wrapper {
    width: 100%;
    color: #222;
    text-align: center;
    .order-list-thead {
      background-color: #fbfbfb;
      height: 40px;
      line-height: 40px;
      border: 1px solid #f5f5f5;
    }
    .order-detail-list {
      td {
        border: 0.5px solid #f5f5f5;
        padding: 10px;
      }
      .goods-name {
        text-align: left;
      }
    }
    .red_word {
      color: #e2333f;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/refund-list.vue